import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {AddCircle} from "@mui/icons-material";
import Box from "@mui/material/Box";
import UserService from "../../../../../API/common/UserService";

const AllRolesTable = ({id, change, setChange}) => {

        const [data, setData] = useState([]);
        const [isFullScreen, setIsFullScreen] = useState(false);
        useEffect(() => {

            UserService.getAllRoles().then(function (response) {
                setData(response.data);
            })
                .catch(function (error) {
                    console.log(error);
                });
        }, []);

        const addRole = useCallback(
            (row) => {
                UserService.addRole(id, row.original)
                    .then(function () {
                        setChange(!change);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            [data],
        );

        const columns = useMemo(
            () => [
                {
                    id: 'name',
                    header: 'Название роли',
                    accessorKey: 'name',
                    minSize: 25,
                },

                {
                    id: 'description',
                    header: 'Описание роли',
                    accessorKey: 'description',
                    minSize: 300,
                },
                {
                    id: 'id',
                    header: 'id',
                    accessorKey: 'id',
                    enableHiding: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                },
            ],
            [data, setData],
        );

        return (
            <>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 0px',
                            m: '0px',
                            "&:after": {
                                display: "none",
                            },
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}
                    isFullScreen={isFullScreen}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 120,
                        },
                    }}
                    columns={columns}
                    data={data}
                    editingMode="modal"
                    enableEditing
                    getRowId={(originalRow) => originalRow.id}
                    renderRowActions={({row, table}) => (
                        <Box sx={{display: 'flex', gap: '1rem'}}>
                            <Tooltip arrow placement="right" title="Добавить роль пользователю">
                                <IconButton color="success" onClick={() => addRole(row)}>
                                    <AddCircle/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                        columnPinning: {left: ['number']}
                    }}
                    localization={MRT_Localization_RU}
                />
            </>
        );
    }
;

export default AllRolesTable;